import { createPrimitiveControlRenderer } from '@web-config-app/entity-form';
import { isAlertBannerSeverityControl } from '../testers/severity-tester';
import { SeverityInputControl } from '../components/severity-control/severity-control.component';

export const severityInputControlRenderer = createPrimitiveControlRenderer(
  isAlertBannerSeverityControl,
  SeverityInputControl,
);

export const alertBannerRenderers = [severityInputControlRenderer];
